import React, { useState } from "react";
import { Card, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";
import IsValidName from "../../../../utils/validators/IsValidName";
import Loading from "../../../home/components/Loading";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import FormActions from "../../components/FormActions";
import { InputField } from "../../components/InputField";
import Roles from "../../../../enums/RoleEnum";
import { IconButton, InputAdornment } from "@material-ui/core";
import { VisibilityOutlined, VisibilityOffOutlined } from "@material-ui/icons";
import { StyledTextField } from "../../../auth/Components/TextField/style";
const roleOptions = [
	{ value: Roles.ADMIN, label: Roles.ADMIN },
	{ value: Roles.USER, label: Roles.USER },
	{ value: Roles.MANAGER, label: Roles.MANAGER }
];

const UsersCreateForm = () => {
	const [formData, setFormData] = useState({
		role: "",
		firstName: "",
		lastName: "",
		email: "",
		password: "",
		confirmPassword: ""
	});

	const [isLoading, setIsLoading] = useState(false);
	const [passwordError, setPasswordError] = useState("");
	const [passwordVisibility, setPasswordVisibility] = useState(false);
	const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState(
		false
	);

	const api = new MutantApiService();

	const handleChange = e => {
		const { name, value } = e.target;
		setFormData(prevFormData => {
			const updatedFormData = { ...prevFormData, [name]: value };
			if (name === "password" || name === "confirmPassword") {
				validatePassword(updatedFormData);
			}
			return updatedFormData;
		});
	};

	const handleRoleChange = value => {
		setFormData({ ...formData, role: value });
	};

	const validatePassword = formData => {
		let isValid = true;
		let error = "";

		if (formData.password.length < 8) {
			error = "A senha deve ter pelo menos 8 caracteres";
			isValid = false;
		} else if (!/[A-Z]/.test(formData.password)) {
			error = "A senha deve conter pelo menos uma letra maiúscula";
			isValid = false;
		} else if (!/[a-z]/.test(formData.password)) {
			error = "A senha deve conter pelo menos uma letra minúscula";
			isValid = false;
		} else if (!/\d/.test(formData.password)) {
			error = "A senha deve conter pelo menos um número";
			isValid = false;
		} else if (!/[!@#$%^&*]/.test(formData.password)) {
			error = "A senha deve conter pelo menos um caractere especial (!@#$%^&*)";
			isValid = false;
		}
		if (formData.password !== formData.confirmPassword) {
			error = "As senhas não coincidem";
			isValid = false;
		}

		setPasswordError(error);
		return isValid;
	};

	const submit = async e => {
		e.preventDefault();
		if (!formIsValid()) {
			return;
		}

		if (!validatePassword(formData)) {
			return;
		}

		setIsLoading(true);
		try {
			await api.makeHttpRequest({
				method: "POST",
				url: "/user",
				data: {
					role: formData.role.value,
					firstName: formData.firstName,
					lastName: formData.lastName,
					email: formData.email,
					password: formData.password
				}
			});
			setIsLoading(false);
			await afterSubmit();
		} catch (e) {
			Swal.fire(
				"Erro!",
				e?.response?.data
					? e.response.data.message
					: "Erro ao cadastrar cliente, tente novamente mais tarde.",
				"error"
			);
		}
		setIsLoading(false);
	};

	const afterSubmit = async () => {
		setFormData({
			role: "",
			firstName: "",
			lastName: "",
			email: "",
			password: "",
			confirmPassword: ""
		});

		await Swal.fire({
			title: "Sucesso!",
			text: "Dados salvos com sucesso.",
			icon: "success",
			confirmButtonText: "Ok",
			cancelButtonText: "Sair"
		});
		onCleanForm();
		window.location.href = "/dashboard/users";
	};

	const onCleanForm = async () => {
		setFormData({
			role: "",
			firstName: "",
			lastName: "",
			email: "",
			password: "",
			confirmPassword: ""
		});
	};

	const formIsValid = () => {
		const { role, firstName, lastName, email } = formData;

		const isFirstNameValid = firstName && IsValidName(firstName);
		const isLastNameValid = lastName && IsValidName(lastName);
		const isEmailValid = email && email.trim() !== "";
		const isRoleValid = role && role.value !== "";
		const valid =
			isFirstNameValid && isLastNameValid && isEmailValid && isRoleValid;
			return valid;
	};

	return (
		<>
			<Loading isLoading={isLoading} />
			<AdminTitle title="Dados do Usuário" disableHeader />
			<Card className="mt-4">
				<StyledCardBody>
					<Form style={{ flex: "1" }}>
						{/* row 1 */}
						<Form.Row as={Col} lg="12" xs="12">
							{/* Nome */}
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="text"
									name="firstName"
									label="Nome"
									placeholder="Digite o nome"
									value={formData.firstName}
									onChange={handleChange}
									isInvalid={
										formData.firstName && !IsValidName(formData.firstName)
									}
								/>
							</Form.Group>
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="text"
									name="lastName"
									label="Sobrenome"
									placeholder="Digite o nome"
									value={formData.lastName}
									onChange={handleChange}
									isInvalid={
										formData.lastName && !IsValidName(formData.lastName)
									}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row as={Col} lg="12" xs="12">
							<Form.Group as={Col} lg="8" xs="12">
								<InputField
									type="text"
									name="email"
									label="E-mail"
									placeholder="Digite o e-mail"
									value={formData.email}
									onChange={handleChange}
									required
								/>
							</Form.Group>
							<Form.Group as={Col} lg="4" xs="12">
								<InputField
									type="text"
									as="select2"
									name="perfil"
									id="perfil"
									label="Perfil"
									placeholder="Selecione o perfil"
									value={formData.role}
									onChange={handleRoleChange}
									required
									options={roleOptions}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row as={Col} lg="12" xs="12">
							<Form.Group as={Col} lg="6" xs="12">
								<StyledTextField
									type={passwordVisibility ? "text" : "password"}
									name="password"
									label="Senha"
									placeholder="Digite a senha"
									value={formData.password}
									onChange={handleChange}
									required
									variant="outlined"
									InputLabelProps={{ shrink: true }}
									style={{ width: "100%" }}
									error={passwordError !== ""}
									helperText={passwordError}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													edge="end"
													onClick={() =>
														setPasswordVisibility(!passwordVisibility)
													}
												>
													{passwordVisibility ? (
														<VisibilityOutlined />
													) : (
														<VisibilityOffOutlined />
													)}
												</IconButton>
											</InputAdornment>
										)
									}}
								/>
							</Form.Group>
							<Form.Group as={Col} lg="6" xs="12">
								<StyledTextField
									type={confirmPasswordVisibility ? "text" : "password"}
									name="confirmPassword"
									label="Confirmar Senha"
									placeholder="Confirme a senha"
									value={formData.confirmPassword}
									onChange={handleChange}
									required
									variant="outlined"
									InputLabelProps={{ shrink: true }}
									error={passwordError !== ""}
									helperText={passwordError}
									style={{ width: "100%" }}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													edge="end"
													onClick={() =>
														setConfirmPasswordVisibility(
															!confirmPasswordVisibility
														)
													}
												>
													{confirmPasswordVisibility ? (
														<VisibilityOutlined />
													) : (
														<VisibilityOffOutlined />
													)}
												</IconButton>
											</InputAdornment>
										)
									}}
								/>
							</Form.Group>
						</Form.Row>
						<FormActions
							onSubmit={submit}
							formIsValid={function(){
								return formIsValid() && passwordError === "";
							}()}
							hideReload={true}
						/>
					</Form>
				</StyledCardBody>
			</Card>
		</>
	);
};

export default UsersCreateForm;
